import { useEffect, useState } from "react";
import { getDepartmentByDate } from "../services/DepartmentApi.js";

export const useDepartment = () => {
  const [departmentName, setDepartmentName] = useState();

  const fetchDepartmentByDate = async (data) => {
    try {
      const res = await getDepartmentByDate(data);
      if (res.status === true) {
        setDepartmentName(res.result);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchDepartmentByDate();
  }, []);

  return { departmentName, fetchDepartmentByDate };
};
